import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

interface Props {
  deliveryStoreId: string;
  isCheckoutPath: boolean;
}
const trackSelectedHomeDeliveryAddress = ({ deliveryStoreId, isCheckoutPath }: Props) => {
  pushGTMEvent({
    event: 'Track',
    category: isCheckoutPath ? 'checkout_delivery_options' : 'delivery_widget',
    action: 'home_delivery_confirmed',
    label: '',
    value: 0,
    delivery_store_id: deliveryStoreId,
  });
};
export default trackSelectedHomeDeliveryAddress;
